import { AppData, BookingData } from "../AppDataProvider";

import { getFirstStep } from "../../utils";
import { Mixpanel } from "../../mixpanel";

export type RestartBookingFlowOpts = {
  appData: AppData;
};

export const restartBookingFlow = (
  options: RestartBookingFlowOpts,
): AppData => {
  Mixpanel.track({ name: "Restarted booking flow" });

  const { bookingTool, bookingData } = options.appData;
  const { forceOrganisationSelection, organisations, services } = bookingTool;

  const { timezone, userDetails, organisation, sessionId, service } =
    bookingData;

  const organisationsStepExists =
    forceOrganisationSelection || organisations.edges.length > 1;

  const urlParams = new URLSearchParams(window.location.search);
  const preFillServiceId = urlParams.get("serviceId");

  const isPrefilledService = !!(bookingData.service && preFillServiceId);

  const servicesStepExists =
    !isPrefilledService &&
    (bookingTool.forceServiceSelection || services.edges.length !== 1);

  const updatedBookingData: BookingData = {
    createdSource: bookingData.createdSource,
    sessionId,
    userDetails,
    ...(!organisationsStepExists &&
      organisation && {
        organisation,
      }),
    ...(!servicesStepExists && { service }),
    timezone,
  };

  return {
    ...options.appData,
    bookingData: updatedBookingData,
    currentStep: getFirstStep({
      bookingData: bookingData,
      bookingTool: bookingTool,
    }),
  };
};
